// extracted by mini-css-extract-plugin
export default {"main":"Accuracy_main__GhjXY","formBox":"Accuracy_formBox__jF1sf","formValue":"Accuracy_formValue__KgiaE","form":"Accuracy_form__AhYtW","btnSubmit":"Accuracy_btnSubmit__xF-LP"};